import { z } from "zod";
import { TaskType } from "./enums";
import { CreateProjectSchema } from "./create";
import { LanguageSchema } from "./schemas";
import { TaskTypeSchema } from "./shared-schemas";

export const TaskInputBaseSchema = z.object({
  type: TaskTypeSchema,
  data: z.record(z.any()),
});

export const TaskOutputBaseSchema = z.object({
  type: TaskTypeSchema,
  data: z.record(z.any()),
});

export const TaskCreateKaraokeOutputDataSchema = z.object({
  projectId: z.string(),
});

export const TaskCreateKaraokeOutputSchema = TaskOutputBaseSchema.extend({
  type: z.literal(TaskType.CreateKaraoke),
  data: TaskCreateKaraokeOutputDataSchema,
});
export const TaskCreateKaraokeInputDataSchema = CreateProjectSchema;

export const TaskCreateKaraokeInputSchema = TaskInputBaseSchema.extend({
  type: z.literal(TaskType.CreateKaraoke),
  data: TaskCreateKaraokeInputDataSchema,
});

export const TaskSyncLyricsInputDataSchema = z.object({
  url: z.string(),
  lyrics: z.string(),
  language: LanguageSchema.optional(),
});

export const TaskSyncLyricsInputSchema = TaskInputBaseSchema.extend({
  type: z.literal(TaskType.SyncLyrics),
  data: TaskSyncLyricsInputDataSchema,
});

export const TaskSyncLyricsOutputDataSchema = z.object({
  alignmentId: z.string(),
});

export const TaskSyncLyricsOutputSchema = TaskOutputBaseSchema.extend({
  type: z.literal(TaskType.SyncLyrics),
  data: TaskSyncLyricsOutputDataSchema,
});

export const TaskExportProjectOutputDataSchema = z.object({
  exportId: z.string(),
  fileId: z.string(),
});

export const TaskExportProjectOutputSchema = TaskOutputBaseSchema.extend({
  type: z.literal(TaskType.ExportProject),
  data: TaskExportProjectOutputDataSchema,
});

export const TaskInputSchema = z.discriminatedUnion("type", [
  TaskCreateKaraokeInputSchema,
  TaskSyncLyricsInputSchema,
]);

export const TaskOutputSchema = z.discriminatedUnion("type", [
  TaskCreateKaraokeOutputSchema,
  TaskSyncLyricsOutputSchema,
  TaskExportProjectOutputSchema,
]);

export type TaskCreateKaraokeInput = z.infer<
  typeof TaskCreateKaraokeInputSchema
>;
export type TaskCreateKaraokeOutput = z.infer<
  typeof TaskCreateKaraokeOutputSchema
>;

export type TaskInput = z.infer<typeof TaskInputSchema>;
export type TaskOutput = z.infer<typeof TaskOutputSchema>;

export type TaskSyncLyricsInput = z.infer<typeof TaskSyncLyricsInputSchema>;
export type TaskSyncLyricsOutput = z.infer<typeof TaskSyncLyricsOutputSchema>;
